import { BrowserRouter as Router } from "react-router-dom";
import { useMemo, useEffect } from "react";

import MainApp from "./apps/main_app";
import IgsosaApp from "./apps/igsosa_app";
import logo from "./images/igs_logo.png";

function App() {
  // 🔒 Stable value (no re-computation issues)
  const subdomain = useMemo(() => {
    return window.location.hostname.split(".")[0];
  }, []);

  useEffect(() => {
    const image = new Image();
    image.src = logo;
    console.log("Logo preloaded " + image.src);
  }, []);

  const isIgsosa = subdomain === "igsosa";

  return (
    <Router>
      <div className="app">
        {isIgsosa ? <IgsosaApp /> : <MainApp />}
      </div>
    </Router>
  );
}

export default App;